export const financingComponent = {
	bindings: {
	},
	templateUrl: 'financing.html',
	controller: class financingComponent {
		constructor() {
		}

		clickOnBlock(blockType, $event) {
			let link = angular.element($event.currentTarget).attr('data-link');
			setTimeout(() => {
				if (link) {
					window.location.href = link;
				}
			}, 500);
		}
	}
};
